const boxChild = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: { xs: "90%" },
};

const signIn = {
  fontWeight: "bold",
  justifyContent: "start",
  alignItems: "start",
  m: 1,
  color: "#212B36",
};

const forgetPassword = {
  display: "flex",
  justifyContent: "end",
  m: 1,
  cursor: "pointer",
  // marginBottom: "32px",
};

const details = (theme) => {
  return { m: 1, color: theme.palette.secondary.text };
};

const formControl = { m: 1 };

export { boxChild, signIn, forgetPassword, formControl, details };
